import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    *{
        box-sizing: border-box;
        margin:0;
        padding:0;
    }

    body,html{
        font-family: ${(props) => props.theme.fonts.main};
        height:100%;
        background-color: ${(props) =>
          !props.dark ? props.theme.colors.light : props.theme.colors.dark1};
    }
`;
